<template>
    <div class="table-template">

        <Section title="文件位置">
            <div style="padding: 20px">src / views / Main / Modules / Table / Table1.vue</div>
        </Section>


        <Section title="表格1">
            <div style="padding: 20px">
                <Table border :columns="columns" :data="data"></Table>
            </div>
        </Section>


        <Section title="表格/分页">
            <div style="padding: 20px">
                <Table border :columns="columns" :data="data"></Table>
                <Page :total="100" :page-size="10" style="text-align: right; margin-top: 20px"></Page>
            </div>
        </Section>


        <Section>
            <LabelHeader border>
                <div slot="before">
                    <span>标签页眉布局</span>
                </div>
                <div slot="after">
                    <Button type="primary" size="small">新增</Button>
                </div>
            </LabelHeader>

            <div style="padding: 20px">
                <Table border :columns="columns" :data="data"></Table>
            </div>

        </Section>

    </div>
</template>

<script>
    import LabelHeader from '@/modules/LabelHeader'

    import { Table, Page, Button } from 'iview';

    export default {
        name: "Table1",
        data () {
            return {
                columns: [
                    {
                        type: 'selection',
                        width: 60,
                        align: 'center'
                    },
                    {
                        title: 'col1',
                        align: 'center',
                        minWidth: 200
                    },
                    {
                        title: 'col2',
                        align: 'center',
                        minWidth: 200
                    },
                    {
                        title: 'col3',
                        align: 'center',
                        minWidth: 200
                    },
                    {
                        title: 'col4',
                        align: 'center',
                        minWidth: 200
                    },
                    {
                        title: 'col5',
                        align: 'center',
                        minWidth: 200
                    }
                ],
                data: []
            }
        },
        components: {
            LabelHeader,
            Table,
            Button,
            Page
        }
    }
</script>

<style scoped>

</style>
